import type { GroupUserDto } from "../../services/UserService";
import type { GroupUser } from "../../state/groupUser";
import { toGrant } from "./grant";
import UserId from "../../state/UserId";

export const toGroupUser = (dto: GroupUserDto): GroupUser => ({
  id: UserId.from(dto.id),
  username: dto.username,
  firstName: dto.firstName,
  lastName: dto.lastName,
  grants: dto.grants.filter(({ customerId }) => customerId >= 0).map(toGrant),
  externallyManaged: dto.externallyManaged,
  disabled: dto.disabled,
});
